import React from 'react';
import ComponentRegistry from './registry/ComponentRegistry';
import HelpAssistant from './common/HelpAssistant';
import './Homepage.css';

const Homepage = () => {
  // You can make tenant dynamic in the future
  const tenant = 'choice';

  return (
    <div className="homepage">
      <ComponentRegistry tenant={tenant} />
      {/* Global floating AI Help Assistant. The homepage bypasses Layout, so
          we mount it here too — every page on the site has the bubble. */}
      <HelpAssistant />
    </div>
  );
};

export default Homepage;